import React from 'react';
import ReactDOM from 'react-dom/client';
import { ThemeProvider } from '@mui/material/styles';
import { CssBaseline, GlobalStyles } from '@mui/material';
import App from './App.jsx';
import { NotificationProvider } from './context/NotificationContext.jsx';
import { theme } from './theme/theme.js';

const globalStyles = (
    <GlobalStyles styles={(theme) => ({
        body: {
            backgroundColor: theme.palette.background.default,
            backgroundImage: `
                radial-gradient(at 0% 0%, hsla(210, 100%, 50%, 0.1) 0px, transparent 50%),
                radial-gradient(at 100% 100%, hsla(228, 98%, 48%, 0.15) 0px, transparent 50%)
            `,
            backgroundAttachment: 'fixed',
            minHeight: '100vh',
            position: 'relative', // Required for z-index stacking context
        },
        'body::before': {
            content: '""',
            position: 'fixed', // Stays in place on scroll
            top: 0,
            left: 0,
            width: '100%',
            height: '100%',
            backgroundImage: `url('https://upload.wikimedia.org/wikipedia/commons/thumb/1/1d/UEFA_Champions_League_logo_no_text_great.svg/768px-UEFA_Champions_League_logo_no_text_great.svg.png?20230109181847')`,
            backgroundRepeat: 'no-repeat',
            backgroundPosition: 'center center',
            backgroundSize: '80vh',
            opacity: 0.02, // Very subtle
            filter: 'brightness(0) invert(1)', // Make the logo white
            zIndex: -1, // Place it behind all content
        },
    })} />
);

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
    <React.StrictMode>
        <ThemeProvider theme={theme}>
            <CssBaseline />
            {globalStyles}
            <NotificationProvider>
                <App />
            </NotificationProvider>
        </ThemeProvider>
    </React.StrictMode>
);
